import request from "../config/axiosConfig";
import { ADD_PARTNER, GET_LIST_PARTNERS, DELETE_PARTNER, PARTNER_STATUS_CHANGE, PARTNER_DETAIL, UPDATE_PARTNER } from "../constants/apiEndPoint";

export const addUpdatePartnerRequest = async (data) => {
    const result = await request({
        url: ADD_PARTNER,
        method: "POST",
        data,
    });
    return result?.data;
};

export const updatePartnerRequest = async (data, id) => {
    const result = await request({
        url: UPDATE_PARTNER,
        method: "POST",
        data: { id, ...data },
    });
    return result?.data;
}

export const getListPartnerRequest = async (params) => {
    const result = await request({
        url: GET_LIST_PARTNERS,
        method: "POST",
        data: params,
    });
    return result?.data?.data;
}

export const deletePartnerRequest = async (id) => {
    const result = await request({
        url: DELETE_PARTNER,
        method: "POST",
        data: { id },
    });
    return result?.data;
}

export const changeStatusPartnerRequest = async (id, status) => {
    const result = await request({
        url: PARTNER_STATUS_CHANGE,
        method: "POST",
        data: { id, status },
    });
    return result?.data;
}

export const getDetailPartnerRequest = async (id) => {
    const result = await request({
        url: PARTNER_DETAIL,
        method: "POST",
        data: { id },
    });
    return result?.data;
};